const dateFormater = (month: string): string => {
  return +month < 10 ? `0${month}` : month;
};
export default dateFormater;
